module.exports = __webpack_public_path__ + "img/bp-yellow.4370ebf9.png";